import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { keyframes } from "@mui/system";

import { getFormatMedia } from "~/theme/utils";

import { STORE_SELECTOR_CLASSES } from "./constants";

export const StoreSelectorDrawer = styled(Drawer)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  const fadeInEffect = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
  return {
    overflow: "auto",
    "& .MuiBackdrop-root": {
      position: "absolute",
      animation: `300ms ${fadeInEffect} ease-out`,
    },
    [`& .${STORE_SELECTOR_CLASSES.drawerContent}`]: {
      overflow: "auto",
      width: "100%",

      [formatMedia.BREAKPOINT_TABLET]: {
        width: 400,
      },
      [formatMedia.BREAKPOINT_DESKTOP]: {
        width: 485,
      },
    },
  };
});
